import {getUserByToken} from "../api/user";
import EventBus from '../api/event-bus.js';
import axios from "axios";

const enhanceAccessToken = () => {
  const { JSTOKEN } = localStorage
  if (!JSTOKEN) return
  axios.defaults.headers.common["X-AUTH-TOKEN"] = JSTOKEN

  return JSTOKEN
}

export default class Auth {
  constructor() {
    // this.currentUser = null;
    this.account = null;
    this.accessToken = enhanceAccessToken()
    // this.groups = [];
    // let self = this;
    if(this.accessToken !== undefined) {
      getUserByToken().then(() => {
        // console.log("AUTH logged on from constructor");
        EventBus.$emit("logon", true);
      });
    }
  }

  isAuthorised(){
    this.accessToken = enhanceAccessToken()

    return this.accessToken !== undefined
  }

  saveAuthInfo(email, password) {
    localStorage.email = email
    localStorage.password = password
  }

  setAccount(item) {
    this.account = item;
  }
  logIn(item) {
    this.account = item;
    // console.log("login");
    // console.log(this.account);
    axios.defaults.headers.common["X-AUTH-TOKEN"] = item.token

    localStorage.JSTOKEN = item.token

    EventBus.$emit("logon", true);
  }

  logOut() {
    this.account = null;
    axios.defaults.headers.common["X-AUTH-TOKEN"] = undefined

    // localStorage.clear()

    EventBus.$emit("logon", false);
  }
  canAccessPicker() {

    if(this.account !== null) {
      if (this.account.type === 'ROLE_ADMIN' || this.account.type === 'ROLE_STOCK_MANAGER') {
        if (this.account.wmsPick === true || this.account.wmsCheck === true || this.account.wmsConfirm === true) {
          return true;
        }
      }
    }
    return false;
  }
  canAccessStock() {
    if(this.account !== null) {
      if ( (this.account.type === 'ROLE_ADMIN' || this.account.type === 'ROLE_STOCK_MANAGER') && this.account.wmsManage === true) {
        return true;
      }
    }
    return false;
  }

  // setUser() {
  //   // console.log("setUser " + localStorage.getItem("JSTOKEN"));
  //   if (localStorage.getItem("JSTOKEN") !== undefined) {
  //     // let self = this;
  //     getUserByToken().then(function (res) {
  //       console.log(res)
  //       // self.currentUser = user;
  //       console.log("AUTH logged on from setUser");
  //       // console.log(self.currentUser);
  //       EventBus.$emit("logon", true);
  //       //self.getOtherUserList();
  //     })
  //       .catch(function(err) {
  //         console.log(err);
  //       })
  //   }
  // }
  // getCurrentUser() {
  //   console.log(this.currentUser)
  //   return this.currentUser;
  // }
}



// WEBPACK FOOTER //
// ./src/store/auth.js